import React from "react";
import { useColorModeValue } from "@chakra-ui/react";
import { BiLogIn } from "react-icons/all";

import { Icon } from "components/Icon";
import { ChakraText } from "components/ChakraText";
import { Button, CustomColorScheme, IButtonProps } from "components/Button";
import { useGetThemeColors } from "ChakraTheme";

interface IProps extends IButtonProps {
  openLoginModal: () => void;
}

const LoginButton = ({ openLoginModal, ...restProps }: IProps) => {
  const colors = useGetThemeColors();
  const iconColor = useColorModeValue(colors.white, colors.black);

  return (
    <Button
      customColorScheme={CustomColorScheme.Green}
      minW="auto"
      h="35px"
      borderRadius={8}
      px={5}
      leftIcon={<Icon color={iconColor} icon={BiLogIn} />}
      onClick={openLoginModal}
      fontSize="lg"
      {...restProps}
    >
      <ChakraText fontSize={restProps.fontSize}>Zaloguj się</ChakraText>
    </Button>
  );
};

export { LoginButton };
